/** SAIT-138, Figma 657:5109, 07.10.2026: СБП 90 × 35,91 и ленивый рейтинг 128 × 22. */
import { ref, computed } from 'ui.vue3';
import { useFooterTrust } from './use-footer-trust';
import './footer-trust-host.css';

const template = `
    <div ref="host" class="footer-trust-host">
        <img class="footer-trust-host__sbp" :src="sbpUrl" width="90" height="35.91" alt="Система быстрых платежей">
        <div class="footer-trust-host__rating" :aria-busy="loading">
            <component v-if="content" :is="content" />
            <template v-else>
                <a class="footer-trust-host__fallback" href="https://yandex.ru/maps/org/tas_pro/1309872468/reviews/" target="_blank" rel="noopener noreferrer">Отзывы на Яндексе</a>
                <button v-if="failed" class="footer-trust-host__retry" type="button" @click="load">Загрузить рейтинг</button>
            </template>
        </div>
    </div>
`;

export const FooterTrustHost = {
    props: { templatePath: { type: String, required: true } },
    emits: [],
    setup(props) {
        const host = ref(null);
        const sbpUrl = computed(() => `${props.templatePath}/img/footer-sbp.svg`);
        return { host, sbpUrl, ...useFooterTrust(host) };
    },
    template,
};
